// スタジオの API（/api/studio）。ユーザー側とはログインが別（qs_studio）
import { createApi } from '@qs/ui/lib/api';

export { ApiError, errorMessage } from '@qs/ui/lib/api';
export const api = createApi('/api/studio');
